import clsx from "clsx";
import type { ReactNode, HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./content.module.css";

type Props = HTMLAttributes<HTMLDivElement> & {
    children: ReactNode;
};

const Content = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { children, className, ...otherProps } = props;

    return (
        <div {...otherProps} ref={ref} className={clsx(styles.content, className)}>
            {children}
        </div>
    );
});

Content.displayName = "Content";

export { Content };
export type { Props as ContentProps };
